import { EnforceConstraint, TemplateType } from "../../globalTypes";
import makeGuardsForModelSubset from "../makeGuardsForModelSubset";

export const hwrTypes = [
  "hwrAdaptationPlan",
  "hwrAnnualEval",
  "hwrPersonalDevPlan",
  "hwrPotentialEval",
] as const;

const explicitSchema = {
  isCalendar: ["calendar"] as const,
  isDetail: ["detail"] as const,
  isItem: ["item"] as const,
  isMultiDetail: ["multiDetail"] as const,
  isNotification: ["notification"] as const,
  isOverview: ["overview"] as const,
  isSsrs: ["ssrs"] as const,
  isHwr: hwrTypes,
  isTopLevel: ["overview", "calendar", ...hwrTypes, "ssrs"] as const,
  hasFunctions: ["overview", "calendar", "detail", "item"] as const,
  hasPresentationModel: [
    "calendar",
    "detail",
    "item",
    "notification",
    "overview",
  ] as const,
  hasStandardDataModel: [
    "calendar",
    "detail",
    "item",
    "notification",
    "overview",
  ] as const,
  canHaveDetail: ["overview", "item"] as const,
  isRepresentedAsATable: ["overview", "item"] as const,
  hasTitle: ["calendar", "notification"] as const,
};

type ApplicableKeys = keyof typeof explicitSchema;

type SchemaKey = keyof typeof explicitSchema;
type CompleteUnion = TemplateType;
type Groups = { [Key in SchemaKey]: typeof explicitSchema[Key][number] };

const criteria = <Key extends ApplicableKeys>(
  key: SchemaKey,
  type: TemplateType
): type is Groups[Key] => {
  const arr = explicitSchema[key];
  return arr.includes(type as never);
};

const guardsForSubset = makeGuardsForModelSubset<
  CompleteUnion,
  SchemaKey,
  Groups
>(criteria);

export default guardsForSubset;

type Check = EnforceConstraint<
  Record<SchemaKey, Readonly<TemplateType[]>>,
  typeof explicitSchema
>;
